/**
 * Action types for TIP GROUP SSID functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_TIP_GROUP_SSID_LIST = 'GET_TIP_GROUP_SSID_LIST';
export const GET_TIP_GROUP_SSID_LIST_SUCCESS =
	'GET_TIP_GROUP_SSID_LIST_SUCCESS';
export const GET_TIP_GROUP_SSID_LIST_FAIL = 'GET_TIP_GROUP_SSID_SCHEDULER_FAIL';
export const DELETE_TIP_GROUP_SSID = 'DELETE_TIP_GROUP_SSID';
export const DELETE_TIP_GROUP_SSID_SUCCESS = 'DELETE_TIP_GROUP_SSID_SUCCESS';
export const DELETE_TIP_GROUP_SSID_FAIL = 'DELETE_TIP_GROUP_SSID_FAIL';
export const OPEN_TIP_GROUP_SSID_MODAL = 'OPEN_TIP_GROUP_SSID_MODAL';
export const ADD_TIP_GROUP_SSID = 'ADD_TIP_GROUP_SSID';
export const ADD_TIP_GROUP_SSID_COMPLETE = 'ADD_TIP_GROUP_SSID_COMPLETE';
export const EDIT_TIP_GROUP_SSID = 'EDIT_TIP_GROUP_SSID';
export const EDIT_TIP_GROUP_SSID_COMPLETE = 'EDIT_TIP_GROUP_SSID_COMPLETE';
export const RESET_ADD_TIP_GROUP_SSID = 'RESET_ADD_TIP_GROUP_SSID';
export const TIP_GROUP_SSID_ADD_TRIGGER = 'TIP_GROUP_SSID_ADD_TRIGGER';
export const TIP_INTERFACE_FETCH_SUCCESS = 'TIP_INTERFACE_FETCH_SUCCESS';
export const TIP_INTERFACE_FETCH_FAIL = 'TIP_INTERFACE_FETCH_FAIL';
